/* Blink&Go: stuurt de knoppen op de hoofdsite naar de online boeking (/pages/afspraak). */
(function(){
const BOOK="/pages/afspraak";
const $=id=>document.getElementById(id);
const size=()=>{const b=document.querySelector("#sizeSeg button[aria-pressed=\"true\"]");return b?b.id.replace("sz-",""):"m"};

/* 0. Klik op "Plan je afspraak" (of "Boek …") = echte add-to-cart in Shopify.
      We zetten de aanbetaling (€20) in de winkelwagen. Shopify ziet dan een actieve winkelwagen
      en de Facebook & Instagram-app stuurt zelf AddToCart naar de Meta Pixel (ook via de server/CAPI).
      Staat de aanbetaling al in de winkelwagen, dan voegen we niets dubbel toe. */
const DEPOSIT_VARIANT=window.BG_DEPOSIT||58137021612414;
async function addDeposit(pakket){
  const J={"Content-Type":"application/json",Accept:"application/json"};
  const c=await fetch("/cart.js",{headers:J}).then(r=>r.json());
  if((c.items||[]).some(i=>i.variant_id==DEPOSIT_VARIANT))return;
  await fetch("/cart/add.js",{method:"POST",headers:J,body:JSON.stringify({items:[{id:DEPOSIT_VARIANT,quantity:1,properties:pakket?{"Pakket":pakket}:{}}]})});
}
document.addEventListener("click",e=>{
  const a=e.target.closest("a[href]");
  if(!a)return;
  const card=a.closest("#pkGrid")&&a.dataset.pick;
  if(!card&&!/\/pages\/afspraak/.test(a.getAttribute("href")||""))return;
  if(e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
  const url=card?BOOK+"?pakket="+a.dataset.pick+"&auto="+size():a.href;
  let pakket="";try{pakket=new URL(url,location.href).searchParams.get("pakket")||""}catch(_){}
  e.preventDefault();e.stopImmediatePropagation();
  let gone=false;const go=()=>{if(!gone){gone=true;location.href=url}};
  setTimeout(go,2500);
  addDeposit(pakket).catch(()=>{}).then(()=>setTimeout(go,150));
},true);

/* 1. Pakketkaarten: "Kies Plus" → "Boek Plus", direct naar de boeking */
const grid=$("pkGrid");
function fixCards(){
  if(!grid)return;
  grid.querySelectorAll("a[data-pick]").forEach(a=>{
    a.href=BOOK+"?pakket="+a.dataset.pick+"&auto="+size();
    if(!a.dataset.bk){a.dataset.bk="1";a.textContent=a.textContent.replace(/^Kies /,"Boek ")}
  });
}
if(grid){fixCards();new MutationObserver(fixCards).observe(grid,{childList:true})}
document.addEventListener("click",e=>{
  const a=e.target.closest("#pkGrid a[data-pick]");
  if(!a)return;
  e.preventDefault();e.stopPropagation();
  location.href=BOOK+"?pakket="+a.dataset.pick+"&auto="+size();
},true);

/* 2. Prijscalculator: "Plan je afspraak" als hoofdknop, WhatsApp als tweede keus */
const wa=$("waBtn"),form=$("calc");
if(wa&&form){
  const bk=document.createElement("a");
  bk.className="btn btn-blue";bk.textContent="Plan je afspraak";
  wa.classList.remove("btn-blue");wa.classList.add("btn-ghost");wa.textContent="Liever via WhatsApp";
  wa.parentNode.insertBefore(bk,wa);
  const upd=()=>{
    const pk=($("cPkg")||{}).value||"";
    const s=(document.querySelector("input[name=csize]:checked")||{}).value||"m";
    const ex=[...document.querySelectorAll("#cExtras input:checked")].map(i=>i.value);
    const q=[];
    if(pk&&!/^(club|none)/.test(pk))q.push("pakket="+pk);
    q.push("auto="+s);
    if(ex.length)q.push("extras="+ex.join(","));
    bk.href=BOOK+"?"+q.join("&");
  };
  ["input","change"].forEach(t=>form.addEventListener(t,upd));
  document.addEventListener("click",e=>{if(e.target.closest("[data-pick]"))setTimeout(upd,0)});
  upd();
}

/* 3. Grote knoppen "Bereken je prijs" → "Plan je afspraak".
      Club-knoppen ("Word lid") gaan naar WhatsApp: een lidmaatschap loopt niet via de afspraakwizard. */
document.querySelectorAll("a.btn[href=\"#boeken\"]").forEach(a=>{
  if(a.closest("#calc"))return;
  const p=a.dataset.pick||"";
  if(/^club-/.test(p)){
    const n=p.slice(5),nm=n.charAt(0).toUpperCase()+n.slice(1);
    a.href="https://wa.me/31687469897?text="+encodeURIComponent("Hoi Blink&Go, ik wil graag lid worden van de Club ("+nm+").");
    a.target="_blank";a.rel="noopener";a.textContent="Word lid via WhatsApp";
    return;
  }
  a.href=BOOK;a.textContent="Plan je afspraak";
});
})();
